import type { FC } from "react"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletTotalUomCellProps {
  pallet: GoodsReceiptPallet
  uomName: string
}

export const GoodsReceiptPalletTotalUomCell: FC<GoodsReceiptPalletTotalUomCellProps> = ({ pallet, uomName }) => {
  return (pallet.goodsReceiptPalletRow?.lots ?? []).map((lot) => (
    <div key={lot.goodsReceiptPalletRowLotId}>
      {lot.totalUom} {uomName}
    </div>
  ))
}
